module.exports = __webpack_public_path__ + "static/media/logoAlt.747ab86e.svg";